export default function useLogger() {
  const loggerLocalStorageKey = "logs";

  const logStorage = useLocalStorage(loggerLocalStorageKey, "[]");

  interface LogMessage {
    timestamp: string;
    message: string;
    params: any[];
  }

  function log(logMessage: string, ...optionalParams: any[]) {
    const runtimeConfigPublic = useRuntimeConfig().public;
    const isProduction =
      runtimeConfigPublic.environment.toLowerCase() == Environment.PRODUCTION;

    if (isProduction) {
      return;
    }

    const timestamp = new Date().toISOString();

    const newLog = {
      timestamp: timestamp,
      message: logMessage,
      params: optionalParams,
    } as LogMessage;

    console.log(newLog);

    const existingLogs = JSON.parse(logStorage.value);
    existingLogs.push(newLog);
    logStorage.value = JSON.stringify(existingLogs);
  }

  function get(): LogMessage[] {
    const runtimeConfigPublic = useRuntimeConfig().public;
    const isProduction =
      runtimeConfigPublic.environment.toLowerCase() == Environment.PRODUCTION;

    if (isProduction) {
      return [];
    }
    return JSON.parse(logStorage.value) as LogMessage[];
  }

  function clear() {
    logStorage.value = JSON.stringify([]);
  }

  return {
    log,
    get,
    clear,
  };
}
